import { IProject } from "../redux/slices/projects";
import { callBffApi } from "./axios";

export const projectsService = {
  getProjects: async () => callBffApi<IProject[]>("get", "/projects"),
};
